import { Api } from "../../services/Api";

export default () => ({
    formData: {
        giftCardNumber: "",
    },
    formMessage: "",
    formError: "",
    formLoading: false,
    buttonText: "Apply",
    init() {
        window.addEventListener("cartUpdate", (event) => {
            const queryParams = new URLSearchParams(window.location.search);
            let number = queryParams.get("number");
            if (window.location.pathname.indexOf("/account/orders/") > -1) {
                number = window.location.pathname.split("/").pop();
            }

            if (number && event.detail.number != number) {
                return;
            }

            this.cart = event.detail;
        });
    },
    reset() {
        this.formMessage = "";
        this.formError = "";
        this.formLoading = false;
        this.buttonText = "Apply";
    },
    async submitForm() {
        if (this.formLoading) {
            return;
        }
        this.reset();
        this.formLoading = true;
        this.buttonText = "Applying...";
        try {
            const res = await Api.post(
                "/actions/redfire-giftcards/cart/add-gift-card",
                {
                    ...this.formData,
                    fromTimezone:
                        Intl.DateTimeFormat().resolvedOptions().timeZone,
                }
            );
            if (res.data.errors && res.data.errors.giftCardNumber) {
                this.reset();
                this.formError = res.data.errors.giftCardNumber;
                return;
            }
            window.location.reload();
        } catch (e) {
            console.error(e);
            this.reset();
            this.formError = "Something went wrong.";
        }
    },
});
